import { Chip } from "@mui/material";
import React, { memo } from "react";

const IsNewChip = ({ label = "Novo", sx }) => {
  return (
    <Chip
      size="small"
      variant="outlined"
      color="success"
      component={"span"}
      sx={{
        border: "none",
        fontWeight: "700",
        fontSize: ".72rem",
        height: 19,
        mr: -1,
        bgcolor: (t) => `#F0FFF1`,
        ...sx,
      }}
      label={label}
    />
  );
};

export default memo(IsNewChip);
